import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import ActiviteCreation from "../../../components/Admin/Activtes/ActiviteCreation";
import ActiviteTypeCreation from "../../../components/Admin/ActiviteTypes/ActiviteTypeCreation";
import ActiviteTypeTable from "../../../components/Admin/ActiviteTypes/ActiviteTypeTable";
import styles from "../../../pages/Admin/Admin.module.css";
import { ReactComponent as AjouterIcone } from "../../../icons/ajouter.svg";
import {fetchSetEntrepriseActif} from "../../../services/EntrepriseService";
import {fetchSetActiviteTypeActif, fetchTypesActiviteAdmin} from "../../../services/ActivitesService";
import ActiviteTypesVue from "../../../components/Admin/ActiviteTypes/ActiviteTypesVue";

function AdminActiviteTypesPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const getActiviteTypes = async () => {
        const response = await fetchTypesActiviteAdmin();
        setMyApiData(response.myActiviteTypes);
    };
    const setImage = async (typeId, urlLogo) => {
        setMyApiData(myApiData.map(type => {
            if (type.actId === typeId) {
                return {
                    ...type,
                    actLogo: urlLogo
                };
            }
            return type;
        }));
    }


    useEffect(() => {
        getActiviteTypes();
    }, [user, mode]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ }));
    }, []);

    const putActifOpenModal = (actType) => {
        const text = actType.actActif ? "supprimer" :  "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} ce type d'activité ?`,
            onConfirm: async () => {
                const response = await fetchSetActiviteTypeActif(actType);
                if (response.success) {
                    handleSuccess(response.message);
                } else {
                    handleError(response.message);
                }
                setTimeout(() => {
                    getActiviteTypes();
                }, 500);
            }
        });
    }
    // { myApiData && <ActiviteTypesVue putActifOpenModal={putActifOpenModal} activitesTypes={myApiData}/> }

    return (
        <div className="content_tab">
            <TitleMain text="Types d'activités"/>
            {mode === 'creation' ?
                <ActiviteTypeCreation activiteType={null} />
                :
                <ActiviteTypesVue putActifOpenModal={putActifOpenModal} activitesTypes={myApiData} setImage={setImage}/>
            }
        </div>
    )
}

export default AdminActiviteTypesPage;
